import React, { createContext, useContext, useState, useEffect } from "react";
import pt from "../i18n/pt.json";
import en from "../i18n/en.json";
import de from "../i18n/de.json";

const translations = { pt, en, de };
const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const getInitialLang = () => {
    const savedLang = localStorage.getItem("app_language");
    return savedLang && translations[savedLang] ? savedLang : "pt";
  };

  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    localStorage.setItem("app_language", lang);
  }, [lang]);

  const t = (keyPath) => {
    return keyPath.split('.').reduce((obj, key) => obj?.[key], translations[lang]) || keyPath;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
